import axios from 'axios'

const api = axios.create({
  baseURL: 'https://api.cameroon.beyond-eocenter.eu/',
  //baseURL: 'http://localhost:9001/',
  withCredentials: false, // Token auth, not cookies
})

const TOKEN_KEY = 'token'

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY)
  //console.log('Attaching token to request', token)
  if (token) {
    // If your Django uses DRF TokenAuth:
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      // Clear token & bounce to login
      localStorage.removeItem(TOKEN_KEY)
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }
    return Promise.reject(err)
  }
)

export default api
export { TOKEN_KEY }
